import { useQuery, UseQueryOptions } from "@tanstack/react-query"
import { API_Error } from "@/interfaces/api/response/api_response_types"
import { API_Data_DynamicUnsubscribeURL_Response } from "@/interfaces/api/self/api_response_types"
import { getDynamicUnsubscribeURL } from "../requests/user"

type DynamicUnsubscribeOptions = Omit<
  UseQueryOptions<API_Data_DynamicUnsubscribeURL_Response, API_Error, API_Data_DynamicUnsubscribeURL_Response, ['dynamicUnsubscribeURL', string]>,
  'queryKey' | 'queryFn'
>

export const useDynamicUnsubscribeURL = (userId?: string, options?: DynamicUnsubscribeOptions) => 
  useQuery<API_Data_DynamicUnsubscribeURL_Response, API_Error, API_Data_DynamicUnsubscribeURL_Response, ['dynamicUnsubscribeURL', string]>({
    queryKey: ['dynamicUnsubscribeURL', userId ?? ''],
    retry: false,
    queryFn: () => getDynamicUnsubscribeURL(userId as string),
    ...options,
    enabled: Boolean(userId) && (options?.enabled ?? true)
  })